import { AxiosResponse } from "axios";
import { Axios } from "../../Axios";
import { TypeEscola } from "../../../Models/Domain/Pessoa/Escola";

export class EscolaService {
    public listar(escola: TypeEscola): Promise<AxiosResponse<TypeEscola[]>> {
        return Axios.post<TypeEscola[]>(`quiron/pessoa/escola/listar`, escola);
    }

    public inserir(escola: TypeEscola) {
        return Axios.post('quiron/pessoa/escola', escola);
    }

    public atualizar(escola: TypeEscola){
        return Axios.put<TypeEscola>('quiron/pessoa/escola', escola);
    }

    public ativar(codigoDaEscola: number){
        return Axios.patch(`quiron/pessoa/escola/ativar/${codigoDaEscola}`);
    }

    public desativar(codigoDaEscola: number){
        return Axios.patch(`quiron/pessoa/escola/desativar/${codigoDaEscola}`);
    }

}

export default EscolaService;